(ns ycweb.app.presence
  (:require
   [ajax.core :as ajax]
   [rum.core :as rum]
   [ycweb.app.common :as yac]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.state :as state]
   [ycweb.components.grid :as grid]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u])

  (:require-macros
   [ycweb.util.core :as yuc]))

(yac/init-sentry)

(enable-console-print!)

(println "Loading Presence Widget.")
(println "Presence Build Number:" (yuc/env :build-number "dev"))

(defn initial-state [started?]
  {:page {:screen :loading}
   :app {:started started? :version (yuc/env :build-number "dev") :app "presence"}
   :device {:screen (state/screen-size) :id (comms/deviceid)}})

(defonce app-atom
  (atom (initial-state false)))

(defn ^:dev/after-load refresh []
  (rum/mount
    (presence/presence-inline-widget app-atom)
    (.getElementById js/document "presence-react-mount"))

  (doseq [e (seq (.getElementsByClassName js/document "presence-inline-mount"))]
    (presence/mount-inline-node app-atom e)))

(defmethod comms/receive :dashboard/start [app-atom e]
  #_(toaster/close-toast app-atom)

  (swap! app-atom
    #(assoc %
       :opts (:opts e)
       :user (:user e)
       :stats (:stats e)
       :config (:config e)))

  (presence/setup-presence-widget app-atom))

(defmethod comms/receive :chsk/state [app-atom [old new]]
  (if (and (:open? new) (not (get-in @app-atom [:comms :started])))
    (do
      (comms/send :dashboard/start {:context (get-in @app-atom [:presence :context])})
      (swap! app-atom assoc-in [:comms :started] true))))

(defmethod grid/action :state/reset [app-atom config _]
  (reset! app-atom
    (merge
      (initial-state true)
      config))
  (comms/send :dashboard/start {:context (get-in @app-atom [:presence :context])})
  (refresh))

(defn main []
  (.addEventListener js/document "DOMContentLoaded"
    (fn []
      (let [node (.getElementById js/document "presence-react-mount")]
        (when node
          (appcommon/entry-main "presence-react-mount" app-atom refresh))))))

(main)